/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Frontend SPA Contract API
 * Canonical API contract entrypoint.
 *
 * Source architecture:
 * - split by module / bounded context
 * - one file per aggregate root
 * - child entities remain owned by aggregate root
 * - cross-cutting technical concerns live under `openapi/common`
 *
 * OpenAPI spec version: 1.0.0
 */
import * as zod from "zod";
import {CustomerOfferDto} from "./customerOfferDto.zod";
import {PaginationMeta2} from "./paginationMeta2.zod";

export const PaginatedCustomerOfferDto = zod.object({
  items: zod.array(CustomerOfferDto),
  meta: PaginationMeta2,
});

export type PaginatedCustomerOfferDto = zod.input<typeof PaginatedCustomerOfferDto>;
export type PaginatedCustomerOfferDtoOutput = zod.output<typeof PaginatedCustomerOfferDto>;
